import { createReducer } from 'typesafe-actions';
import { defaultErrorHandler, defaultRequestHandler } from '../dataFetching/generators';
import { LookPromotionsState, LookPromotion, LookPromotionRawData } from './types';
import { fetchLooksPromotionActions, LooksPromotionActionType } from './actions';

export const defaultLooksPrmotionalElements: LookPromotionsState = {
    isFetching: false,
    didInvalidate: false,
    identifier: '',
    promotions: [],
};

const getPositions = (position: unknown) => {
    if (Array.isArray(position)) {
        return position;
    }
    return [];
};

export const mapPromotionData = (data: LookPromotionRawData[]): LookPromotion[] => {
    return data.reduce(
        (promotions, promotion) => [
            ...promotions,
            ...getPositions(promotion.position).map(position => ({
                title: promotion.headline,
                category: promotion.category,
                color: promotion.backgroundColor,
                cta: promotion.cta,
                link: promotion.link,
                image: promotion.image.file.url,
                position: Number.parseInt(position, 10),
            })),
        ],
        []
    );
};

export const looksPromotionalElementsReducer = createReducer<LookPromotionsState, LooksPromotionActionType>(
    defaultLooksPrmotionalElements
)
    .handleAction(fetchLooksPromotionActions.success, (state, action) => {
        const {
            data: { data: responseData },
            identifier,
        } = action.payload;

        return {
            ...state,
            promotions: mapPromotionData(responseData),
            isFetching: false,
            identifier,
        };
    })
    .handleAction(fetchLooksPromotionActions.failure, (state, action) => defaultErrorHandler(state, action))
    .handleAction(fetchLooksPromotionActions.request, (state, action) => {
        return defaultRequestHandler(state, action);
    });
